import React from 'react';

interface CreditsIconProps {
  className?: string;
  /** size in px; defaults to the surrounding font size */
  size?: number | string;
}

/**
 * The credits glyph — a big four-point sparkle with a small one beside it.
 * One mark for every credit count in the product (header, prices, packs);
 * it takes the surrounding text colour.
 */
const CreditsIcon: React.FC<CreditsIconProps> = ({ className, size = '1em' }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
    style={{ display: 'inline-block', verticalAlign: '-0.125em' }}
  >
    <path d="M11 3c.5 5.2 2.8 7.5 8 8-5.2.5-7.5 2.8-8 8-.5-5.2-2.8-7.5-8-8 5.2-.5 7.5-2.8 8-8z" />
    <path d="M19 2c.3 1.7.9 2.3 2.6 2.6-1.7.3-2.3.9-2.6 2.6-.3-1.7-.9-2.3-2.6-2.6 1.7-.3 2.3-.9 2.6-2.6z" />
  </svg>
);

export default CreditsIcon;
